module.exports = __webpack_public_path__ + "static/media/3pic@3x.c17ad5bd.png";